import {storeInstance} from '@aofl/store/dist/legacy';
import {sdoNs} from './constants-enumerate';
import {deepAssign} from '@aofl/object-utils';

const sdo = {
  namespace: sdoNs.USER_SEARCH,
  mutations: {
    init() {
      return {
        queryObj: {
          search: {},
          filters: {},
          sort: {},
          selection_mode: null,
          persistent_selection: [],
          not_selected: [],
          total_results: 0
        },
        results: [],
        tableConfig: [],
        allSelected: false,
        hasMore: false,
        selected: [],
        searchTargetUrl: '',
        profileTargetUrl: '',
        defaultQueryObj: {},
        pendingFilters: {}
      };
    },
    setQuerySearchQuery(subState, query) {
      return deepAssign(subState, 'queryObj.search', {
        query
      });
    },
    setQuerySearchField(subState, field) {
      return deepAssign(subState, 'queryObj.search', {
        field
      });
    },
    setQuerySortFields(subState, field) {
      return deepAssign(subState, 'queryObj.sort', {
        fields: [field, 'id']
      });
    },
    setQueryFilters(subState, filters) {
      return deepAssign(subState, 'queryObj', {
        filters
      });
    },
    setFiltersGroupPath(subState, path) {
      return deepAssign(subState, 'queryObj.filters', {
        group_path: path
      });
    },
    setPendingFiltersGroupPath(subState, path) {
      return deepAssign(subState, 'pendingFilters', {
        group_path: path
      });
    },
    setPendingFiltersLicenseStatus(subState, status) {
      return deepAssign(subState, 'pendingFilters', {
        license_status: status,
      });
    },
    setPendingFiltersProduct(subState, product) {
      return deepAssign(subState, 'pendingFilters', {
        aofl_product: product
      });
    },
    setPendingFiltersLicense(subState, license) {
      return deepAssign(subState, 'pendingFilters', {
        license_id: license
      });
    },
    setPendingFiltersGrade(subState, grade) {
      return deepAssign(subState, 'pendingFilters', {grade});
    },
    setPendingFiltersProductConflict(subState, productConflict) {
      return deepAssign(subState, 'pendingFilters', {product_conflict: productConflict});
    },
    setPendingFiltersInvitationStatus(subState, status) {
      return deepAssign(subState, 'pendingFilters', {
        invitation_status: status
      });
    },
    setPendingFiltersClassroomId(subState, id) {
      return deepAssign(subState, 'pendingFilters', {
        classroom_id: id
      });
    },
    setPendingFiltersRosterId(subState, id) {
      return deepAssign(subState, 'pendingFilters', {
        roster_job_id: id
      });
    },
    setClassAssignment(subState, assignment) {
      return deepAssign(subState, 'pendingFilters', {
        class_assigned: assignment
      });
    },
    setRoleAssignment(subState, assignment) {
      return deepAssign(subState, 'pendingFilters', {
        role_assigned: assignment
      });
    },
    updateSortOrder(subState, {index, field}) {
      let direction = subState.queryObj.sort.direction;
      if (direction === 'asc') {
        direction = 'desc';
      } else if (direction === 'desc') {
        direction = '';
      } else {
        direction = 'asc';
      }

      let fields = [field, 'id'];
      if (direction === '') fields = ['id'];

      return deepAssign(subState, 'queryObj.sort', {
        direction,
        fields,
      });
    },
    removeSortLastValues(subState) {
      const nextSubState = deepAssign(subState, 'queryObj.sort', {});

      nextSubState.queryObj.sort.is_forward = true;
      if (typeof nextSubState.queryObj.sort.last_values !== 'undefined') {
        delete nextSubState.queryObj.sort.last_values;
      }

      return nextSubState;
    },
    select(subState, {id}) {
      const index = subState.selected.indexOf(id);
      if (index === -1) {
        subState = Object.assign({}, subState, {
          selected: [
            ...subState.selected,
            id
          ]
        });
      }
      if (subState.queryObj.persistent_selection.indexOf(id) === -1 && subState.queryObj.selection_mode !== 'all') {
        subState.queryObj.persistent_selection.push(id);
      }

      const indexNotSelected = subState.queryObj.not_selected.indexOf(id);
      if (indexNotSelected !== -1) {
        subState.queryObj.not_selected = [
          ...subState.queryObj.not_selected.slice(0, indexNotSelected),
          ...subState.queryObj.not_selected.slice(indexNotSelected + 1)
        ];
      }

      return subState;
    },
    selectAll(subState, {selectionMode}) {
      let newSubState = Object.assign({}, subState);
      newSubState.queryObj.selection_mode = selectionMode;

      for (let i = 0; i < subState.results.length; i++) {
        newSubState = sdo.mutations.select(newSubState, {id: subState.results[i].id});
      }

      if (selectionMode === 'all') {
        newSubState.queryObj.persistent_selection = [];
      }
      newSubState.queryObj.not_selected = [];

      return newSubState;
    },
    selectPage(subState, {selectionMode}) {
      return this.selectAll(subState, {selectionMode});
    },
    deselect(subState, {id}) {
      const index = subState.selected.indexOf(id);
      if (index > -1) {
        subState = Object.assign({}, subState, {
          selected: [
            ...subState.selected.slice(0, index),
            ...subState.selected.slice(index + 1)
          ]
        });
      }

      const persistentSelectionIndex = subState.queryObj.persistent_selection.indexOf(id);
      if (persistentSelectionIndex > -1) {
        subState.queryObj.persistent_selection = [
          ...subState.queryObj.persistent_selection.slice(0, persistentSelectionIndex),
          ...subState.queryObj.persistent_selection.slice(persistentSelectionIndex + 1)
        ];
      }

      if (subState.queryObj.selection_mode === 'all' && subState.queryObj.not_selected.indexOf(id) === -1) {
        subState.queryObj.not_selected.push(id);
      }
      return subState;
    },
    deselectAll(subState) {
      const newSubState = Object.assign({}, subState);
      newSubState.queryObj.selection_mode = null;
      newSubState.queryObj.persistent_selection = [];
      newSubState.queryObj.not_selected = [];
      newSubState.selected = [];
      return Object.assign({}, subState, newSubState);
    },
  },
  decorators: [
    (nextState) => { // prev search query
      const state = storeInstance.getState();
      const nextSubState = nextState[sdoNs.USER_SEARCH];
      const subState = state[sdoNs.USER_SEARCH];

      if (typeof nextSubState.$prevQueryObj === 'undefined' || nextSubState.queryObj !== subState.queryObj) {
        const $prevQueryObj = subState.queryObj;

        nextState = deepAssign(nextState, `${sdoNs.USER_SEARCH}`, {$prevQueryObj});
      }

      return nextState;
    },
    (nextState) => { // prev pointer items
      const state = storeInstance.getState();
      const nextSubState = nextState[sdoNs.USER_SEARCH];
      const subState = state[sdoNs.USER_SEARCH];

      if (typeof nextSubState.$prev === 'undefined' || nextSubState.results !== subState.results) {
        let $prev = '';
        if (nextSubState.results.length > 0) {
          $prev = nextSubState.results[0]; /** @todo assign needed props */
        }

        nextState = deepAssign(nextState, `${sdoNs.USER_SEARCH}`, {$prev});
      }

      return nextState;
    },
    (nextState) => { // next pointer items
      const state = storeInstance.getState();
      const nextSubState = nextState[sdoNs.USER_SEARCH];
      const subState = state[sdoNs.USER_SEARCH];

      if (typeof nextSubState.$next === 'undefined' ||
      nextSubState.results !== subState.results) {
        let $next = '';
        if (nextSubState.results.length > 0) {
          $next = nextSubState.results[nextSubState.results.length - 1]; /** @todo assign needed props */
        }

        nextState = deepAssign(nextState, `${sdoNs.USER_SEARCH}`, {$next});
      }

      return nextState;
    },
    (nextState) => { // set results[].{$selected}
      const state = storeInstance.getState();
      const nextSubState = nextState[sdoNs.USER_SEARCH];
      const subState = state[sdoNs.USER_SEARCH];
      if (nextSubState.results !== subState.results ||
          nextSubState.selected !== subState.selected ||
          nextSubState.queryObj.selection_mode !== subState.queryObj.selection_mode) {
        const results = [];

        for (let i = 0; i < nextSubState.results.length; i++) {
          const group = nextSubState.results[i];
          if (
            nextSubState.selected.indexOf(group.id) !== -1 ||
            nextSubState.queryObj.selection_mode === 'all' ||
            nextSubState.queryObj.persistent_selection.indexOf(group.id) !== -1
          ) {
            let isSelected = true;
            if (nextSubState.queryObj.not_selected.indexOf(group.id) > -1) {
              isSelected = false;
            }
            results.push(Object.assign({}, group, {
              $selected: isSelected
            }));
          } else if (group.$selected === true) {
            results.push(Object.assign({}, group, {
              $selected: false
            }));
          } else {
            results.push(group);
          }
        }
        nextState = deepAssign(nextState, `${sdoNs.USER_SEARCH}`, {results});
      }

      return nextState;
    },
    (nextState) => { // set $transferableLicensesSelected
      const state = storeInstance.getState();
      const nextSubState = nextState[sdoNs.USER_SEARCH];
      const subState = state[sdoNs.USER_SEARCH];
      if (nextSubState.results !== subState.results || nextSubState.selected !== subState.selected) {
        let $transferableLicensesSelected = false;
        for (let i = 0; i < nextSubState.results.length; i++) {
          const group = nextSubState.results[i];
          if (group.$selected && group.has_transferable_license) {
            $transferableLicensesSelected = true;
            break;
          }
        }
        nextState = deepAssign(nextState, `${sdoNs.USER_SEARCH}`, {$transferableLicensesSelected});
      }

      return nextState;
    },
    (nextState) => { // $search to make api call
      const state = storeInstance.getState();

      const nextSubState = nextState[sdoNs.USER_SEARCH];
      const subState = state[sdoNs.USER_SEARCH];

      if (typeof nextSubState.$search === 'undefined' ||
      nextSubState.queryObj.search !== subState.queryObj.search) {
        let $search = void 0;

        if (nextSubState.queryObj.search.query && nextSubState.queryObj.search.query !== '') {
          $search = Object.assign({}, nextSubState.queryObj.search);
        }

        nextState = deepAssign(nextState, sdoNs.USER_SEARCH, {
          $search
        });
      }

      return nextState;
    },
    (nextState) => { // $filters to make api call
      /** @todo remove group filter cases */
      const state = storeInstance.getState();

      const nextSubState = nextState[sdoNs.USER_SEARCH];
      const subState = state[sdoNs.USER_SEARCH];

      if (
        typeof nextSubState.$filters === 'undefined' ||
        nextSubState.queryObj.filters !== subState.queryObj.filters
      ) {
        let $filters = Object.assign({}, nextSubState.queryObj.filters);

        if (Array.isArray($filters.parent_group_id) && $filters.parent_group_id.length > 0) {
          $filters = Object.assign({}, $filters, {
            parent_group_id: $filters.parent_group_id[$filters.parent_group_id.length - 1]
          });
        } else if (Array.isArray(nextSubState.queryObj.filters.group_path)
            && nextSubState.queryObj.filters.group_path.length) {
          const path = nextSubState.queryObj.filters.group_path;
          let sessionPath = state[sdoNs.SESSION].group_info.path + state[sdoNs.SESSION].group_info.id;
          sessionPath = sessionPath.split('.');

          path.forEach((value, key) => {
            if (sessionPath.indexOf(value.toString()) < 0) {
              sessionPath.push(value);
            }
          });

          $filters = Object.assign({}, $filters, {
            group_path: sessionPath.join('.') + '.'
          });
        } else if (Array.isArray($filters.classes_path)) {
          const path = nextSubState.queryObj.filters.classes_path;
          $filters = Object.assign({}, $filters, {
            path: nextState[sdoNs.SESSION].group_info.id + '.' + path.join('.') + '.'
          });
          delete $filters.classes_path;
        } else {
          delete $filters.parent_group_id;
          delete $filters.group_path;
        }
        nextState = deepAssign(nextState, sdoNs.USER_SEARCH, {
          $filters
        });
      }

      return nextState;
    },
    (nextState) => { // $filterLicenseStatus
      const state = storeInstance.getState();

      const nextSubState = nextState[sdoNs.USER_SEARCH];
      const subState = state[sdoNs.USER_SEARCH];

      if (typeof nextSubState.$filterLicenseStatus === 'undefined' ||
        nextSubState.pendingFilters.license_status !== subState.pendingFilters.license_status) {
        const $filterLicenseStatus = nextSubState.pendingFilters.license_status;
        nextState = deepAssign(nextState, sdoNs.USER_SEARCH, {$filterLicenseStatus});
      }
      return nextState;
    },
    (nextState) => { // $filterProduct
      const state = storeInstance.getState();

      const nextSubState = nextState[sdoNs.USER_SEARCH];
      const subState = state[sdoNs.USER_SEARCH];

      if (typeof nextSubState.$filterProduct === 'undefined' ||
        nextSubState.pendingFilters.aofl_product !== subState.pendingFilters.product) {
        const $filterProduct = nextSubState.pendingFilters.aofl_product;
        nextState = deepAssign(nextState, sdoNs.USER_SEARCH, {$filterProduct});
      }
      return nextState;
    },
    (nextState) => { // $filterLicense
      const state = storeInstance.getState();

      const nextSubState = nextState[sdoNs.USER_SEARCH];
      const subState = state[sdoNs.USER_SEARCH];

      if (typeof nextSubState.$filterLicense === 'undefined' ||
        nextSubState.pendingFilters.license_id !== subState.pendingFilters.license) {
        const $filterLicense = nextSubState.pendingFilters.license_id;
        nextState = deepAssign(nextState, sdoNs.USER_SEARCH, {$filterLicense});
      }
      return nextState;
    },
    (nextState) => { // $filterGrade
      const state = storeInstance.getState();

      const nextSubState = nextState[sdoNs.USER_SEARCH];
      const subState = state[sdoNs.USER_SEARCH];

      if (typeof nextSubState.$filterGrade === 'undefined' ||
        nextSubState.pendingFilters.grade !== subState.pendingFilters.grade) {
        const $filterGrade = nextSubState.pendingFilters.grade;
        nextState = deepAssign(nextState, sdoNs.USER_SEARCH, {$filterGrade});
      }
      return nextState;
    },
    (nextState) => { // $sort to make api call
      const state = storeInstance.getState();

      const nextSubState = nextState[sdoNs.USER_SEARCH];
      const subState = state[sdoNs.USER_SEARCH];

      if (typeof nextSubState.$sort === 'undefined' ||
      nextSubState.queryObj.sort !== subState.queryObj.sort) {
        const $sort = Object.assign({}, nextSubState.queryObj.sort);
        if ($sort.direction === '') {
          $sort.direction = 'asc';
        }

        nextState = deepAssign(nextState, sdoNs.USER_SEARCH, {
          $sort
        });
      }

      return nextState;
    },
    (nextState) => { // $filterInvitationStatus
      const state = storeInstance.getState();

      const nextSubState = nextState[sdoNs.USER_SEARCH];
      const subState = state[sdoNs.USER_SEARCH];

      if (typeof nextSubState.$filterInvitationStatus === 'undefined' ||
          nextSubState.pendingFilters.invitation_status !== subState.pendingFilters.invitation_status) {
        const $filterInvitationStatus = nextSubState.pendingFilters.invitation_status;
        nextState = deepAssign(nextState, sdoNs.USER_SEARCH, {$filterInvitationStatus});
      }
      return nextState;
    },
    (nextState) => { // $filtered results
      /** @todo revisit logic */
      const state = storeInstance.getState();

      const nextSubState = nextState[sdoNs.USER_SEARCH];
      const subState = state[sdoNs.USER_SEARCH];

      if (typeof nextSubState.$filtered === 'undefined' ||
      nextSubState.queryObj.filters !== subState.queryObj.filters) {
        let $filtered = false;
        if (Object.keys(nextSubState.$filters).length > 1 ||
        (typeof nextSubState.$filters.level === 'undefined')) {
          $filtered = true;
        }

        nextState = deepAssign(nextState, sdoNs.USER_SEARCH, {
          $filtered
        });
      }

      return nextState;
    },
    (nextState) => { // $pageNumber
      const state = storeInstance.getState();
      const nextSubState = nextState[sdoNs.USER_SEARCH];
      const subState = state[sdoNs.USER_SEARCH];

      if (
        typeof nextSubState.$pageNumber === 'undefined'
        ||
        nextSubState.hasMore !== subState.hasMore
        ||
        nextSubState.$sort !== subState.$sort
      ) {
        const hasOffset = Boolean(nextSubState.$sort.last_values);
        let $pageNumber = 1;
        let $numPages = 3;

        if (nextSubState.$sort.is_forward) {
          if (hasOffset) {
            $pageNumber = 2;
          }

          if (!nextSubState.hasMore) {
            $numPages = $pageNumber;
          }
        } else {
          $pageNumber = nextSubState.hasMore ? 2 : 1;
        }

        nextState = deepAssign(nextState, `${sdoNs.USER_SEARCH}`, {$pageNumber, $numPages});
      }

      return nextState;
    },
    (nextState) => { // $selectedRosterFile
      const state = storeInstance.getState();
      const nextSubState = nextState[sdoNs.USER_SEARCH];
      const subState = state[sdoNs.USER_SEARCH];

      if (typeof nextSubState.$selectedRosterFile === 'undefined' ||
      nextSubState.pendingFilters?.roster_job_id !== subState.pendingFilters?.roster_job_id || // eslint-disable-line
      nextState[sdoNs.USER_JOBS].$rosterFiles !== state[sdoNs.USER_JOBS].$rosterFiles
      ) {
        const $selectedRosterFile = nextState[sdoNs.USER_JOBS].$rosterFiles
          .find((item) => item.id === parseInt(nextSubState.pendingFilters?.roster_job_id, 10)); // eslint-disable-line

        nextState = deepAssign(nextState, sdoNs.USER_SEARCH, {$selectedRosterFile});
      }

      return nextState;
    }
  ]
};

storeInstance.addState(sdo);
